import { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_INPUT_GENERICO, ESTILO_BOTON_GENERAL_CANCELAR } from "../../utils/const/estilos-const";
import "../../style/style-cargando.css";
import ArrowBack from "../../components/arrow-back";
import { useTranslation } from "react-i18next";
import ProcessingDialog from "../../components/processing-dialog";
import ToastComponent from "../../components/toast-component";
import { Copy, Check, ExternalLink, FileDown } from "lucide-react";
import { sharedExportarPdf } from "../../utils/shared-functions";

export default function DetalleIncidentePage() {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const contentRef = useRef(null);
  const [cargandoPage, setCargandoPage] = useState(true);
  const [formData, setFormData] = useState(null);
  const [titulo, setTitulo] = useState("");
  // const [listaCategoria, setListaCategoria] = useState([]);
  // const [categoriaSelected, setCategoriaSelected] = useState(null);

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning");
  const [copiedKey, setCopiedKey] = useState("");
  const [openedKey, setOpenedKey] = useState("");

  useEffect(() => {
    // console.log("entro a DetalleIncidentePage");
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log("data");
      // console.log(data);
      if (data !== undefined && data !== null) {
        setFormData(data.params);
        setTitulo(data.titulo);

      }

    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      setCargandoPage(false);
    }
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  const handleCopyValue = async (value, key) => {
    try {
      const text = String(value ?? "").trim();
      if (!text || text === "-") {
        showToast("No hay valor para copiar", "warning", 2500);
        return;
      }
      await navigator.clipboard.writeText(text);
      setCopiedKey(key);
      window.clearTimeout(handleCopyValue._timer);
      handleCopyValue._timer = window.setTimeout(() => {
        setCopiedKey("");
      }, 1500);
      showToast(t("alert_copiado_al_portapapeles"), "success", 2000);
    } catch (err) {
      console.log("handleCopyValue err");
      console.log(err);
      showToast("No se pudo copiar al portapapeles", "error", 2500);
    }
  };

  const handleOpenLink = (url, key) => {
    try {
      const link = String(url ?? "").trim();
      if (!link || link === "-") {
        showToast("No hay enlace para abrir", "warning", 2500);
        return;
      }
      window.open(link, "_blank", "noopener,noreferrer");
      setOpenedKey(key);
      window.clearTimeout(handleOpenLink._timer);
      handleOpenLink._timer = window.setTimeout(() => {
        setOpenedKey("");
      }, 1500);
    } catch (err) {
      console.log("handleOpenLink err");
      console.log(err);
      showToast("No se pudo abrir el enlace", "error", 2500);
    }
  };

  const IncidenteLocationMap = ({ latitud, longitud }) => {
    const lat = parseFloat(latitud);
    const lng = parseFloat(longitud);
    const hasValidCoords = Number.isFinite(lat) && Number.isFinite(lng);
    const embedUrl = hasValidCoords
      ? `https://maps.google.com/maps?q=${lat},${lng}&z=16&output=embed`
      : "";
    const latDisplay =
      latitud != null && String(latitud).trim() !== ""
        ? String(latitud).trim()
        : hasValidCoords
          ? String(lat)
          : "—";
    const lngDisplay =
      longitud != null && String(longitud).trim() !== ""
        ? String(longitud).trim()
        : hasValidCoords
          ? String(lng)
          : "—";

    return (
      <div className="bg-white border border-gray-200 rounded-md p-3 h-full">
        <div className="text-sm font-semibold text-gray-700 mb-2">{t("label_ubicacion")}</div>
        {hasValidCoords ? (
          <>
            <iframe
              title="ubicacion-incidente"
              src={embedUrl}
              data-pdf-map-static
              data-lat={lat}
              data-lng={lng}
              className="w-full rounded-md border border-gray-200"
              style={{ minHeight: "330px" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
            <div className="mt-3 pt-2 border-t border-gray-200 text-sm text-gray-800 space-y-1">
              <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
                <span className="font-medium text-gray-600 shrink-0">{t("column_latitud")}</span>
                <span className="tabular-nums font-mono text-gray-900 break-all">{latDisplay}</span>
              </div>
              <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
                <span className="font-medium text-gray-600 shrink-0">{t("column_longitud")}</span>
                <span className="tabular-nums font-mono text-gray-900 break-all">{lngDisplay}</span>
              </div>
            </div>
          </>
        ) : (
          <div className="min-h-[330px] flex flex-col">
            <div className="flex-1 flex items-center justify-center text-sm text-gray-500 border border-dashed border-gray-300 rounded-md min-h-[200px]">
              {t("label_sin_coordenadas_validas")}
            </div>
            {(latitud != null && String(latitud).trim() !== "") ||
            (longitud != null && String(longitud).trim() !== "") ? (
              <div className="mt-3 pt-2 border-t border-gray-200 text-sm text-gray-800 space-y-1">
                <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
                  <span className="font-medium text-gray-600 shrink-0">{t("column_latitud")}</span>
                  <span className="tabular-nums font-mono text-gray-900 break-all">{latDisplay}</span>
                </div>
                <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
                  <span className="font-medium text-gray-600 shrink-0">{t("column_longitud")}</span>
                  <span className="tabular-nums font-mono text-gray-900 break-all">{lngDisplay}</span>
                </div>
              </div>
            ) : null}
          </div>
        )}
      </div>
    );
  };

  const CopyActionButton = ({ onClick, copied }) => {
    return (
      <button
        type="button"
        className={`flex items-center gap-1 transition-colors ${copied ? "text-green-600" : "text-gray-500 hover:text-gray-700"}`}
        onClick={onClick}
        title={copied ? t("label_copiado") : t("label_copiar")}
      >
        {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
        <span className="text-xs">{copied ? t("label_copiado") : t("label_copiar")}</span>
      </button>
    );
  };

  const OpenLinkActionButton = ({ onClick, opened }) => {
    return (
      <button
        type="button"
        className={`flex items-center gap-1 transition-colors ${opened ? "text-green-600" : "text-blue-600 hover:text-blue-700"}`}
        onClick={onClick}
        title={opened ? t("label_abierto") : t("label_abrir_en_nueva_pestana")}
      >
        {opened ? <Check className="h-4 w-4" /> : <ExternalLink className="h-4 w-4" />}
        <span className="text-xs">{opened ? t("label_abierto") : t("label_abrir")}</span>
      </button>
    );
  };

  const IncidenteDetalleItem = ({ item, index, onCopyValue, copied, onOpenLink, opened }) => {
    const tipo = (item?.tipo || "").toLowerCase();
    const isImageType = tipo === "fotografia" || tipo === "firma";
    const value = item?.value ?? "-";
    const imageLabel = tipo === "fotografia" ? t("label_fotografia") : t("label_firma");

    return (
      <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
        <div className="border border-gray-200 rounded-md p-4 bg-white">
          <div className="text-sm font-semibold text-gray-700 mb-2">
            {tipo ? `${tipo.charAt(0).toUpperCase()}${tipo.slice(1)}` : `Detalle ${index + 1}`}
          </div>
          {isImageType ? (
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 lg:col-span-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  URL {imageLabel}
                </label>
                <input
                  type="text"
                  value={value}
                  className={ESTILO_INPUT_GENERICO}
                  readOnly
                />
                <div className="flex justify-end mt-2">
                  <CopyActionButton
                    copied={copied}
                    onClick={() => onCopyValue(value)}
                    t={t}
                  />
                </div>
              </div>
              <div className="col-span-12 lg:col-span-8">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  {t("label_vista_previa")}
                </label>
                <div className="border border-gray-200 rounded-md p-2 bg-gray-50">
                  {/* Do not set crossOrigin here: GCS without CORS headers would block the image in the UI.
                      PDF export retries with CORS only on the html2canvas clone (shared-functions applyPdfExportCloneFixes). */}
                  <img
                    src={value}
                    alt={imageLabel}
                    className="max-h-72 w-auto rounded-md"
                  />
                </div>
                <div className="flex justify-end mt-2">
                  <OpenLinkActionButton
                    opened={opened}
                    onClick={() => onOpenLink(value)}
                    t={t}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {t("label_valor")}
              </label>
              <input
                type="text"
                value={value}
                className={ESTILO_INPUT_GENERICO}
                readOnly
              />
            </div>
          )}
        </div>
      </div>
    );
  };

  const render = () => {
    // console.log('render correo');
    try {
      // if (cargandoPage === true) {
      //   return cargandoCard();
      // }
      // if (cargandoPage === false && formData === null) {
      //   return (
      //     <div>
      //       <label> Sin data</label>
      //     </div>
      //   );
      // }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6 bg-gray-100"
          ref={contentRef}
        >
          <br />
          <div className="bg-white py-6 shadow-md rounded-lg sm:px-2">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <ArrowBack onClick={handleCancelClick} />
                  <h2 className="text-xl font-bold text-gray-900">{titulo}</h2>
                </div>
              </div>
              <button
                type="button"
                onClick={() =>
                  void sharedExportarPdf(
                    contentRef,
                    `Detalle-Incidente-${formData?.labelPlaca ?? "sin-placa"}`
                  )
                }
                className="flex items-center gap-2 px-3 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg text-sm font-medium"
              >
                <FileDown className="h-4 w-4" />
                {t("label_exportar_pdf")}
              </button>
            </div>
            {/* sharedExportarPdf only captures nodes with data-pdf-block (see shared-functions.js) */}
            <div data-pdf-block className="space-y-4">
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 lg:col-span-6">
                <div className="grid grid-cols-12 gap-4">
                  <div className="col-span-12 md:col-span-6 lg:col-span-6">
                    <label className="block text-md font-medium text-gray-700 mb-1">
                      {t("column_estado_incidente")}
                    </label>
                    <input
                      type="text"
                      value={formData?.estadoIncidente ?? "-"}
                      className={ESTILO_INPUT_GENERICO}
                      readOnly
                    />
                  </div>
                  <div className="col-span-12 md:col-span-6 lg:col-span-6">
                    <label className="block text-md font-medium text-gray-700 mb-1">
                      {t("column_sub_estado_incidente")}
                    </label>
                    <input
                      type="text"
                      value={formData?.subEstadoIncidente ?? "-"}
                      className={ESTILO_INPUT_GENERICO}
                      readOnly
                    />
                  </div>
                  <div className="col-span-12 md:col-span-6 lg:col-span-6">
                    <label className="block text-md font-medium text-gray-700 mb-1">
                      {t("column_placa")}
                    </label>
                    <input
                      type="text"
                      value={formData?.labelPlaca ?? "-"}
                      className={ESTILO_INPUT_GENERICO}
                      readOnly
                    />
                  </div>
                  <div className="col-span-12 md:col-span-6 lg:col-span-6">
                    <label className="block text-md font-medium text-gray-700 mb-1">
                      {t("column_nombre_chofer")}
                    </label>
                    <input
                      type="text"
                      value={formData?.nombreChofer ?? "-"}
                      className={ESTILO_INPUT_GENERICO}
                      readOnly
                    />
                  </div>
                  <div className="col-span-12 md:col-span-6 lg:col-span-6">
                    <label className="block text-md font-medium text-gray-700 mb-1">
                      {t("column_fecha_hora_incidente")}
                    </label>
                    <input
                      type="text"
                      value={formData?.fechaHoraIncidente ?? "-"}
                      className={ESTILO_INPUT_GENERICO}
                      readOnly
                    />
                  </div>
                  <div className="col-span-12 md:col-span-6 lg:col-span-6">
                    <label className="block text-md font-medium text-gray-700 mb-1">
                      {t("column_fecha_registro")}
                    </label>
                    <input
                      type="text"
                      value={formData?.fechaRegistro ?? "-"}
                      className={ESTILO_INPUT_GENERICO}
                      readOnly
                    />
                  </div>
                  <div className="col-span-12 md:col-span-6 lg:col-span-6">
                    <label className="block text-md font-medium text-gray-700 mb-1">
                      {t("column_latitud")}
                    </label>
                    <input
                      type="text"
                      value={formData?.latitud ?? "-"}
                      className={ESTILO_INPUT_GENERICO}
                      readOnly
                    />
                    <div className="flex justify-end mt-2">
                      <CopyActionButton
                        copied={copiedKey === "latitud"}
                        onClick={() => handleCopyValue(formData?.latitud ?? "", "latitud")}
                      />
                    </div>
                  </div>
                  <div className="col-span-12 md:col-span-6 lg:col-span-6">
                    <label className="block text-md font-medium text-gray-700 mb-1">
                      {t("column_longitud")}
                    </label>
                    <input
                      type="text"
                      value={formData?.longitud ?? "-"}
                      className={ESTILO_INPUT_GENERICO}
                      readOnly
                    />
                    <div className="flex justify-end mt-2">
                      <CopyActionButton
                        copied={copiedKey === "longitud"}
                        onClick={() => handleCopyValue(formData?.longitud ?? "", "longitud")}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-span-12 lg:col-span-6">
                <IncidenteLocationMap
                  latitud={formData?.latitud}
                  longitud={formData?.longitud}
                />
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              {Array.isArray(formData?.detalle) && formData.detalle.length > 0 ? (
                formData.detalle.map((item, index) => (
                  <IncidenteDetalleItem
                    key={item?.id || `${item?.tipo || "detalle"}-${index}`}
                    item={item}
                    index={index}
                    onCopyValue={(value) => handleCopyValue(value, `detalle-${index}`)}
                    copied={copiedKey === `detalle-${index}`}
                    onOpenLink={(value) => handleOpenLink(value, `detalle-${index}`)}
                    opened={openedKey === `detalle-${index}`}
                    t={t}
                  />
                ))
              ) : (
                <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                  <div className="border border-dashed border-gray-300 rounded-md p-4 text-sm text-gray-500">
                    {t("label_sin_detalle")}
                  </div>
                </div>
              )}
            </div>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="flex justify-between">
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_CANCELAR}
                    onClick={handleCancelClick}
                  >
                    {t("label_cancelar")}
                  </button>
                </div>
              </div>
            </div>
            </div>
          </div>
          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
        </div>
      );
    } catch (err) {
      console.log('formData render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
